module.exports = __webpack_public_path__ + "images/dingtalk/init-projects-92185c1a7045a04c483b2d8fc02c7e36.png";